import React from "react";
import Label from "./Label";
import { inputClassName, inputErrorClassName } from "./classNames";
import ErrorIcon from "../Icons/ErrorIcon";

const TextInput = ({
  id,
  label,
  type = "text",
  placeholder = "Enter your text",
  register,
  errors,
}) => {
  return (
    <div>
      <Label htmlFor={id} label={label} />
      <input
        id={id}
        type={type}
        autoComplete={id}
        placeholder={placeholder}
        className={inputClassName}
        {...register}
      />
      {errors && errors[id] && (
        <div className="text-red-500 text-sm mt-1 flex items-center">
          <ErrorIcon />
          <span>{errors[id].message}</span>
        </div>
      )}
    </div>
  );
};

export default TextInput;
